import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'

import { App } from './ui/App'
import { installerReferentiel } from './db/seed'
import { demanderPersistance, enregistrerServiceWorker } from './pwa/register'
import './ui/styles.css'

/**
 * `HashRouter` et non `BrowserRouter` : en mode standalone iOS, les URL
 * profondes servies par le serveur sont une source connue d'ecrans blancs au
 * relancement de l'app (la page est rechargee depuis le cache du service
 * worker, et la route ne resout pas toujours). Le routage par fragment est
 * entierement gere cote client et supprime le probleme — ainsi que le besoin
 * d'une regle de repli SPA cote Apache.
 */

async function demarrer() {
  try {
    await installerReferentiel()
  } catch (e) {
    console.error("Echec de l'installation du referentiel d'ingredients", e)
  }

  void demanderPersistance()
  enregistrerServiceWorker()

  const racine = document.getElementById('root')
  if (!racine) throw new Error('Element racine introuvable')

  createRoot(racine).render(
    <StrictMode>
      <HashRouter>
        <App />
      </HashRouter>
    </StrictMode>,
  )
}

void demarrer()
